<script setup>
import { computed, ref } from 'vue'
import ShowScheduleVerticalTile from '@components/show-schedule-vertical-tile'

const INITIAL_VISIBLE_ITEMS = 3
const ADDITIONAL_VISIBLE_ITEMS = 5

const props = defineProps({
    playlist: {
        type: Array,
        default: () => [],
    },
})

const visiblePlaylistItems = ref(INITIAL_VISIBLE_ITEMS)

const upcomingMixes = computed(() =>
    props.playlist.slice(1, 1 + visiblePlaylistItems.value)
)

const canLoadMore = computed(() => visiblePlaylistItems.value < props.playlist.length - 1)

function showMore() {
    visiblePlaylistItems.value += ADDITIONAL_VISIBLE_ITEMS
}
</script>

<template>
    <div class="show-schedule-vertical-block">
        <div class="heading show-schedule-head">Up Next</div>
        <transition-group
            name="fade"
            tag="div"
        >
            <ShowScheduleVerticalTile
                v-for="item in upcomingMixes"
                :key="`${item.id}`"
                :playlist-item="item"
            />
        </transition-group>
        <div :class="['load-more', !canLoadMore && 'load-more-disabled']">
            <BaseButton
                :modifiers="{
                    fill: true,
                }"
                button-type="secondary"
                @click="showMore"
            >
                SHOW MORE
            </BaseButton>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.show-schedule-vertical-block {
    padding-bottom: $size-music-player;
}

.show-schedule-head {
    padding-bottom: $s-xs;
    font-size: 11px;
    color: $c-text-faded;
}

.load-more {
    margin-top: $s-s;

    &-disabled {
        pointer-events: none;
        opacity: 0.2;
    }
}
</style>
